import { Formik } from "formik";
import styles from "./ProfilePage.module.css";
import MembershipSection from "./components/MembershipSection/MembershipSection";
import ProfileImageSection from "./components/ProfileImageSection/ProfileImageSection";
import PersonalInfoSection from "./components/PersonalInfoSection/PersonalInfoSection";
import SaveProfileSection from "./components/SaveProfileSection/SaveProfileSection";
import validationSchema from "./form/validationSchema";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import api from "../../services/axiosConfig";
import { GET_USER } from "../../constant-value";
import profileInitialValues from "./form/initialValues";
import { toast } from "react-toastify";
import { setUser } from "../../redux/user/userSlice";


const ProfilePage = () => {

    const user = useSelector((state) => state.user.user);

    const dispatch = useDispatch();

    const [initialValues, setInitialValues] = useState(profileInitialValues);

    const [isLoading, setIsLoading] = useState(true);

    const loadUser = async () => {

        try {
    
            const result = await api.get(
    
                `/${GET_USER}${user.userId}`
    
            );
    
            const data = result.data;
    
            const formValues = {
    
                fullName: data.fullName || "",
    
                id: user.userId,
    
                userName: data.userName || "",
    
                gender: data.gender ?? true,
    
                birthDate: data.birthDate || "",
    
                registerDate: data.registerDate || "",
    
                expireDate: data.expireDate || "",
    
                lastLoginDate: data.lastLoginDate || "",
    
                imageUrl: data.imageUrl || "",
    
                imageFile: null,
    
            };
    
            setInitialValues(formValues);
    
            dispatch(
    
                setUser({
    
                    ...user,
    
                    fullName: data.fullName,
    
                    imageUrl: data.imageUrl,
    
                })
    
            );
    
        } catch (err) {
    
            console.log(err);
    
        }
    
    };

    // const subscription = {};

    useEffect(() => {

        loadUser()
    
            .finally(() => setIsLoading(false));
    
    }, [user.userId]);

    if (isLoading || !initialValues) {

        return (
            <div className="container mt-5 text-center">
              <div className="py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">در حال دریافت اطلاعات کاربر...</p>
              </div>
            </div>
        );
    
    }

    const submitProfile = async (

        values,
    
        actions
    
    ) => {
        try {
          const fd = new FormData();
  
          // فیلدها
        //   fd.append("Id", values.id);
        //   fd.append("FullName", values.fullName);
        //   fd.append("UserName", values.userName);
        //   fd.append("Gender", values.gender);
        //   fd.append("BirthDate", values.birthDate ?? "");
          Object.keys(values).forEach((key) => {
            fd.append(key, values[key] ?? "");
          });
 
          // فایل تصویر
          if (values.imageFile) {

            fd.append("profileImage", 
                        
                        values.imageFile,

                        values.imageFile.name);

         }
 
          const res = await api.put(`/api/users/${user.userId}`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
          });
  
          if (res.data.isSuccess) {

            toast.success(res.data.message);

            await loadUser();           

          }
          else toast.warn(res.data.message);

        } catch (err) {

          toast.error("خطا در ذخیره اطلاعات!");

        } finally {

            actions.setSubmitting(false);

        }
    };

    return (

        <Formik

            initialValues={initialValues}

            enableReinitialize

            validationSchema={validationSchema}

            onSubmit={submitProfile}

        >

            {({

                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                setFieldValue,

                isSubmitting,

            }) => {

                return(
                    <main className={styles.page}>

                        <MembershipSection

                            membershipDate = {values.registerDate}

                            expireDate = {values.expireDate}

                            lastLogin = {values.lastLoginDate}

                        />

                        <ProfileImageSection

                            values={values}

                            setFieldValue={setFieldValue}

                        />

                        <PersonalInfoSection

                            values={values}

                            errors={errors}

                            touched={touched}

                            handleChange={handleChange}

                            handleBlur={handleBlur}

                            setFieldValue={setFieldValue}

                        />

                        <SaveProfileSection

                            loading={isSubmitting}

                            onSubmit={handleSubmit}

                        />

                    </main>
                )
            }}

        </Formik>

    );

};

export default ProfilePage;